module.exports = __webpack_public_path__ + "static/media/otago_basic.8f07b15a.png";